const PrintFull = (reciptDetails, item, fullAddress) => {
  const formattedAddress = (fullAddress || "").replace(/,/g, ",&nbsp;");

  const deliveryInfo =
    item.orderType === "home_delivery"
      ? `
        <p class="textSizeMid">
            Delivery Partner Name: ${
              item.delivery_person_name || "Not assigned"
            }
        </p>
        <p class="textSizeMid">
            Delivery Partner Mobile No.: ${
              item.delivery_person_number || "Not assigned"
            }
        </p>`
      : "";

  const printWindow = window.open("", "_blank");

  const customerReceiptHTML = `
  <html>
    <head>
      <style>
        @page {
          size: 80mm;
          margin: 0;
        }

        body {
          margin: 0;
          padding: 0 6px;
          font-family: Arial, sans-serif;
          font-size: 16px;
          color: black;
        }

        .header {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          border-bottom: 1px dashed #000;
          line-height: 1.1;
        }

        .header2 {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          border-bottom: 1px dashed #000;
          line-height: 1.5;
        }

        .headerTable {
          width: 100%;
          border-bottom: 1px dashed #000;
        }

        .headerTotal {
          display: flex;
          flex-direction: column;
          border-bottom: 1px dashed #000;
          padding: 4px 0;
        }

        .headerEnd {
          text-align: center;
        }

        .flex-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
   margin: 3px 0;
}

.amount {
  min-width: 65px;
  text-align: right;
  padding-right: 8px; 
}

        .textSizeLarge {
          font-size: 16px;
          margin: 1px;
        }

        .textSizeMid {
          font-size: 12px;
          margin: 0px;
        }

        .textSizeSmall {
          font-size: 9px;
          margin: 1px;
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }

        th, td {
          font-size: 12px;
          padding: 4px 2px;
          text-align: center;
        }
      </style>
    </head>

    <body>

      <div class="header">
        <p class="textSizeLarge"><b>${reciptDetails.business_name}</b></p>
        <p class="textSizeMid">${reciptDetails.address}</p>
        <p class="textSizeMid">PH: ${reciptDetails.phone_no}</p>
        <p class="textSizeMid">GST NO: ${reciptDetails.gst}</p>
        ${
          reciptDetails.fssaiNo
            ? `<p class="textSizeMid">FSSAI NO: ${reciptDetails.fssaiNo}</p>`
            : ""
        }
        <p class="textSizeLarge"><b>** INVOICE **</b></p>
      </div>

      <div class="header2">
        <p class="textSizeMid">Order No: ${item.daily_order_id} / ${
          item.orderid
        }</p>
        <p class="textSizeMid">Order Type: ${item.orderType}</p>
        <p class="textSizeMid">Customer Name: ${item.customer_name}</p>
        <p class="textSizeMid">Customer Mobile: ${item.customer_mobile}</p>
        <p class="textSizeMid">Payment Status: ${item.payment_status}</p>
        <p class="textSizeMid">Payment Mode: ${item.payment_mode}</p>
        <p class="textSizeMid">Order Date: ${item.order_date}</p>

        ${deliveryInfo}

        ${
          item.orderType === "home_delivery"
            ? `<p class="textSizeMid">Delivery Address: ${formattedAddress}</p>`
            : ""
        }

        ${
          item.orderType === "dining"
            ? `<p class="textSizeMid">Table No: ${item.table_no}</p>`
            : ""
        }

        ${
          item.orderType === "car_order"
            ? `<p class="textSizeMid">Vehicle No.: ${item.table_no}</p>`
            : ""
        }

        ${
          item.orderType === "office_order"
            ? `<p class="textSizeMid">Office No.: ${item.table_no}</p>`
            : ""
        }
      </div>

      <div class="headerTable">
        <table>
          <thead>
            <tr>
              <th>Sr</th>
              <th>Item</th>
              <th>Qty</th>
              <th>Price</th>
              <th>Total</th>
            </tr>
          </thead>

          <tbody>
            ${item.items
              ?.map((subitem, index) => {
                let customizationText = "";

                try {
                  const customization =
                    subitem.customization && subitem.customization !== "{}"
                      ? JSON.parse(subitem.customization)
                      : null;

                  if (customization) {
                    const parts = Object.values(customization);
                    customizationText = parts.length
                      ? `<div>(${parts.join(" | ")})</div>`
                      : "";
                  }
                } catch {}

                return `
                  <tr>
                    <td>${index + 1}</td>
                    <td>${subitem.product_id} ${customizationText}</td>
                    <td>${subitem.quantity}</td>
                    <td>${Number(subitem.item_price).toFixed(2)}</td>
                    <td>${Number(subitem.total_price).toFixed(2)}</td>
                  </tr>
                `;
              })
              .join("")}
          </tbody>
        </table>
      </div>

    <div class="headerTotal">

  <div class="flex-row">
    <span class="textSizeMid">Sub Total :</span>
    <span class="textSizeMid amount">Rs. ${Number(item.subtotal).toFixed(2)}</span>
  </div>

  ${
    item.gst_claim === "Y"
      ? `
  <div class="flex-row">
    <span class="textSizeMid">CGST (2.5%) :</span>
    <span class="textSizeMid amount">Rs. ${Number(item.tax_cgst || 0).toFixed(2)}</span>
  </div>
  <div class="flex-row">
    <span class="textSizeMid">SGST (2.5%) :</span>
    <span class="textSizeMid amount">Rs. ${Number(item.tax_sgst || 0).toFixed(2)}</span>
  </div>
  `
      : ""
  }

  <div class="flex-row">
    <span class="textSizeMid">Delivery Fee :</span>
    <span class="textSizeMid amount">Rs. ${Number(item.delivery_fee || 0).toFixed(2)}</span>
  </div>

  <div class="flex-row">
    <span class="textSizeMid">Other Fee :</span>
    <span class="textSizeMid amount">Rs. ${Number(item.other_fee || 0).toFixed(2)}</span>
  </div>

  <div class="flex-row" style="font-weight:600;">
    <span class="textSizeMid">Total Amount :</span>
    <span class="textSizeMid amount">Rs. ${Number(item.pay_amount).toFixed(2)}</span>
  </div>

</div>

<div class="header2">
  <div class="flex-row">
    <span class="textSizeMid">Paid Amount :</span>
    <span class="textSizeMid amount">Rs. ${Number(item.pay_amount).toFixed(2)}</span>
  </div>
</div>

      <div class="headerEnd">
        <p class="textSizeMid">Thank you for your purchase!</p>
        <p class="textSizeSmall">
          * Order Managed By Chaafo*
        </p>
      </div>

    </body>
  </html>
  `;

  printWindow.document.write(customerReceiptHTML);
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
  printWindow.close();
};

export default PrintFull;
